export const getDraftFlowRoute = (projectId, sessionId) => {
  if (!projectId) {
    return sessionId ? `/draft-flow/${sessionId}` : "/draft-flow";
  }

  const baseRoute = `/projects/${projectId}/draft-flow`;
  return sessionId ? `${baseRoute}/${sessionId}` : baseRoute;
};
